import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import Title from './modal-window-title';

const ImageInputModal = ({
    children,
    open,
    title,
    onClose,
    contentClassName,
    contentSx,
    ...rest
}) => {
    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            aria-labelledby="image-modal-title"
            {...rest}
            open={open}
            onClose={onClose}
        >
            <Title id="image-modal-title" onClose={onClose}>
                { title }
            </Title>
            <DialogContent className={contentClassName} sx={contentSx}>
                { children }
            </DialogContent>
        </Dialog>
    );
};

ImageInputModal.propTypes = {
    children: PropTypes.node,
    open: PropTypes.bool,
    title: PropTypes.string,
    onClose: PropTypes.func,
    contentClassName: PropTypes.string,
    contentSx: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.func,
        PropTypes.object,
    ]),
};

export default ImageInputModal;
